var map = {
	"./1.svg": 74889,
	"./10.svg": 36982,
	"./2.svg": 52158,
	"./3.svg": 95942,
	"./4.svg": 41477,
	"./5.svg": 64299,
	"./6.svg": 20501,
	"./7.svg": 35832,
	"./8.svg": 95694,
	"./9.svg": 13712,
	"./animals.svg": 59843,
	"./babysitting.svg": 12615,
	"./diy.svg": 4379,
	"./events.svg": 17093,
	"./gardening.svg": 73982,
	"./housekeeping.svg": 74322,
	"./it.svg": 14148,
	"./s_cat/10.svg": 80460,
	"./s_cat/11.svg": 32139,
	"./s_cat/2.svg": 87077,
	"./s_cat/3.svg": 65859,
	"./s_cat/4.svg": 98555,
	"./s_cat/5.svg": 42894,
	"./s_cat/6.svg": 7421,
	"./s_cat/7.svg": 17262,
	"./s_cat/8.svg": 56176,
	"./s_cat/9.svg": 90104,
	"./support.svg": 90047,
	"./transporter.svg": 56767,
	"./well-being.svg": 63073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47887;